module.exports = __webpack_public_path__ + "static/media/XYON_uses_Curoflow_telemedicine_software.16e01fc4.webp";